export const CashWarrantService = {
  mapWarrants: (warrants) =>
    warrants.map((warrant) => ({
      id: warrant.id,
      warrantID1C: warrant.warrantID1C,
      sum: warrant.sum,
      type: warrant.type,
      isPaidOff: warrant.isPaidOff,
      url: warrant.url,
      selected: warrant.cashboxID,
      comment: warrant.comment,
      isGettingBy1C: warrant.isGettingBy1C,
      conduct: warrant.conduct,
      nonConduct: warrant.nonConduct,
      pdfBill: warrant.pdfBill,
      isReadyFor1C: warrant.isReadyFor1C,
      createdNow: false,
    })),
};
